if (document.querySelectorAll('button[name="SubmitAlert"]').length > 0){


function SubmitAlert(event) {
  var productSKU = document.getElementById("txtProductSKU").value;
  var emailAddress = document.getElementById("txtEmailAddress").value
  var alertCode = document.getElementById("hdnAlertCode").value;

  _ltk.Alerts.AddAlertWithIdentifiers({
    Identifiers: { Email: emailAddress },
    Sku: productSKU,
    AlertCode: alertCode,
  });
  _ltk.Alerts.Submit();
  // alert("Thank you! We will notify you when this product becomes available.");
  
   event.target.closest(".block_notify-btn").querySelector("#back_in-stock").innerHTML =  "Thank you! We will notify you when this product becomes available.";
  setTimeout(() => {
    location.reload();
  } , 2000)
}

let alertButton = document.querySelector('button[name="SubmitAlert"]');
alertButton.addEventListener('click', SubmitAlert);

function toggleNotify(event){
   let target = event.target;
   document.querySelector(".back-stock-alert").classList.toggle("hidden");
}

function enableButton(event){
  if(event.target.value.length > 0){
    event.target.closest(".block_notify-btn").querySelector(".out-of-stock-btn").disabled = false;
  }else{
    event.target.closest(".block_notify-btn").querySelector(".out-of-stock-btn").disabled = true;
  }
}
}